import { shallowMount } from "@vue/test-utils";
import Sucursal from "@/views/Sucursal";

describe("Sucursal component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Sucursal);
  });

  it("Renders del component Sucursal", () => {
    expect(wrapper).toBeDefined();
  });
});
